import React from 'react'
import HeadingArea from '../../general/HeadingArea';

import { useState, useEffect } from 'react';
import axios from 'axios';
import ResponseMsg2 from '../../general/ResponseMsg2';
import { RiDeleteBin6Line } from 'react-icons/ri';
import { AiOutlinePlusCircle, AiOutlineMinusCircle } from 'react-icons/ai';
import { FaCheck } from 'react-icons/fa';
import { FaCopy } from 'react-icons/fa';

const ExamSetup = ({ setLoading }) => {

    const [response2, setResponse2] = useState({ message: '', status: 'success' });
    const [searchTerm, setSearchTerm] = useState('');
    const [academicYears, setAcademicYears] = useState([]);
    const [showDelete, setShowDelete] = useState(false);
    const [selectedExam, setSelectedExam] = useState({});
    const [exam, setExam] = useState([]);
    const [examSetup, setExamSetup] = useState([]);

    const [form, setForm] = useState({
        examType: '',
        class_name: '',
        section: '',
        year: '',
        subject: '',
        total: '',
        examDate: ''
    })


    const [classes, setClasses] = useState([]);
    const [availableSections, setAvailableSections] = useState([]);
    const [selectedClassId, setSelectedClassId] = useState('');
    const [selectedSection, setSelectedSection] = useState('');
    const [subjects, setSubjects] = useState([]);
    const [assignedSubjects, setAssignedSubjects] = useState([]);

    const [rows, setRows] = useState([
        { examTitle: '', examMark: '' },
    ]);


    const handleAddRow = (e) => {
        e.preventDefault();
        setRows((prev) => [...prev, { examTitle: '', examMark: '' }]);
    };





    const handleRemoveRow = (index) => {
        const updated = [...rows];
        updated.splice(index, 1);
        setRows(updated);
    };

    const handleChangeRow = (index, field, value) => {
        const updated = [...rows];
        updated[index][field] = value;
        setRows(updated);
    };



    const total = Array.isArray(rows)
        ? rows.reduce((sum, row) => {
            const mark = parseFloat(row.examMark);
            return sum + (isNaN(mark) ? 0 : mark);
        }, 0)
        : 0;


    useEffect(() => {

        setForm(prev => ({
            ...prev,
            total: total
        }));
    }, [total]);


    const formatForDateInput = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    if (isNaN(date)) return ''; // fallback
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
};


    const handleCopyStructure = (exam) => {
    if (!exam) return;

    // Parse class_name if stored as JSON
    let classObj = {};
    try {
        classObj = exam.class_name ? JSON.parse(exam.class_name) : {};
    } catch (err) {
        classObj = { classId: '', className: '' };
    }

    // Populate the form
    setForm({
        examType: exam.exam_type_id || '',
        class_name: classObj,
        section: exam.section || '',
        year: exam.year || '',
        subject: exam.subject || '',
        total: exam.total_marks || '',
 examDate: formatForDateInput(exam.exam_date)
    });


    let distribution = [];
    try {
        distribution = exam.exam_mark_distribution
            ? JSON.parse(exam.exam_mark_distribution)
            : [];
    } catch (err) {
        distribution = [];
    }

    setRows(distribution.length > 0 ? distribution : [{ examTitle: '', examMark: '' }]);

    setSelectedClassId(classObj.classId || '');
    setSelectedSection(exam.section || '');
    fetchAssignSubject(classObj.classId || '', exam.section || '');
};


    const handleChange = (e) => {
        const { name, value } = e.target;

        if (name === 'class_name') {
            const selectedClass = classes.find((cls) => cls.id.toString() === value);
            setForm((prev) => ({
                ...prev,
                class_name: selectedClass
                    ? { classId: selectedClass.id, className: selectedClass.class_name }
                    : '',
            }));

        } else if (name == "total") {
  setForm(prev => ({
    ...prev,
    total: value
  }));
}
 else {
            setForm((prev) => ({
                ...prev,
                [name]: value,
            }));
        }
    };


    const fetchExamTypeDetail = async () => {
        setLoading(true)
        try {
            const res = await axios.get('https://api.kcian.in/fetch-exam-type');
            setExam(res.data);
            // console.log(res.data);
            setLoading(false);
        } catch (error) {
            console.log(error)
            setLoading(false)
        }
    };





    const fetchClasses = async () => {
        setLoading(true);
        try {
            const response = await fetch('https://api.kcian.in/get-classes');

            if (response.ok) {
                const data = await response.json();
                setClasses(data);
                setLoading(false);


            } else {
                setLoading(false);
                console.error('Failed to fetch class');
            }
        } catch (error) {
            setLoading(false);
            console.error('Error fetching data:', error);
        }
    }


    const fetchAcademicYears = async () => {
        setLoading(true);
        try {
            const response = await fetch('https://api.kcian.in/get-academic-years');
            if (response.ok) {
                const data = await response.json();
                console.log(data);
                setAcademicYears(data);
            } else {
                console.error('Failed to fetch academic years');
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (form.class_name && form.class_name.classId) {
            const selectedClass = classes.find(
                (cls) => cls.id === Number(form.class_name.classId)
            );

            if (selectedClass && selectedClass.sections) {
                const sectionArray = selectedClass.sections
                    .split(',')
                    .map((s) => s.trim())
                    .filter((s) => s !== '');

                setAvailableSections(sectionArray);
            } else {
                setAvailableSections([]);
            }

            setSelectedSection('');
        }
    }, [form.class_name, classes]);


    useEffect(() => {

        fetchClasses();
        fetchAcademicYears();
        fetchSubjects();
        fetchExamTypeDetail();
        fetchExamSetup();
        fetchAcademicYears();

    }, [])



    const handleSubmit = async (e) => {

        e.preventDefault();

        setLoading(true);
        console.log(form);


        try {
            const response = await axios.post(
                'https://api.kcian.in/add-exam-setup',
                {
                    form,
                    // rows,
                },

                {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            );
            console.log('POST request sent successfully');


            fetchExamSetup();

            setResponse2({
                message: 'Exam Created Successfully !',
                status: 'success'
            });
            setForm({
                examType: '',
                class_name: '',
                section: '',
                ay: '',
                subject: '',
                total: '',
                year: '',
                examDate: null,
            });

            setRows([
                { examTitle: '', examMark: '' }
            ]);



            setTimeout(() => {
                setResponse2('');
            }, 2000);

            setLoading(false);
        } catch (error) {
            console.error('Error submitting form:', error);
            setResponse2({ message: 'Server error. Please try again later.', status: 'error' });
            setTimeout(() => {
                setResponse2('');
            }, 2000);
            setLoading(false);
        }
    };





    const fetchExamSetup = async () => {
        setLoading(true);
        try {
            const res = await axios.get('https://api.kcian.in/fetch-exam-setup');


            // setExamSetup(res.data);
            console.log(res.data)

            const processed = res.data.map(item => ({
                ...item,
                class_name: JSON.parse(item.class_name).className
            }));
            setExamSetup(processed);

            setLoading(false);
        } catch (error) {
            console.log('Fetch Error:', error);
            setLoading(false);
        }
    };



    const filterExamSetup = examSetup.filter((tt) => {
        const term = searchTerm.toLowerCase();

        return (
            (tt.section?.toLowerCase() || '').includes(term) ||
            (tt.sub_name?.toLowerCase() || '').includes(term) ||
            (tt.class_name?.toLowerCase() || '').includes(term) ||
            (tt.exam_name?.toLowerCase() || '').includes(term)
        );
    });

    const handleDelete = async (examId) => {
        setLoading(true);
        try {
            const response = await axios.delete(`https://api.kcian.in/delete-exam/${examId}`);

            setResponse2({ message: 'Exam Removed successfully!', status: 'success' });
            setShowDelete(false);
            fetchExamSetup();
            setTimeout(() => {
                setResponse2('');
            }, 3000);
            setLoading(false)
        } catch (error) {
            console.error('Error deleting fee particular:', error);
            setShowDelete(false);
              const backendMessage =
            error.response?.data?.message || "Something Went Wrong. Please try again.";

        setResponse2({ message: backendMessage, status: 'error' });
            // setResponse2({ message: 'Something Went Wrong. Please try again.', status: 'error' });
            setTimeout(() => {
                setResponse2('');
            }, 3000);
            setLoading(false);
        } }

    const handleShowDelete = (data) => {
        setSelectedExam(data);
        setShowDelete(true);
    }


    const fetchSubjects = async () => {
        setLoading(true);
        try {
            const response = await fetch('https://api.kcian.in/get-subjects');

            if (response.ok) {
                const data = await response.json();
                setSubjects(data);
                setLoading(false);
            } else {
                setLoading(false);
                console.error('Failed to fetch class');
            }
        } catch (error) {
            setLoading(false);
            console.error('Error fetching data:', error);
        }
    }


    const fetchAssignSubject = async (classId = selectedClassId, section = selectedSection) => {
        console.log('function call')
        if (!classId || !section) {
            // setResponse2({ message: 'Please select class and section before searching', status: 'error' });
            return;
        }

        try {
            setLoading(true);
            const res = await fetch(`https://api.kcian.in/fetch-assigned-subject?class_id=${classId}&section=${section}`);

            const data = await res.json();
            console.log(data);

            if (res.ok) {
                if (data.length > 0) {
                    const mappedAssignments = data.map(item => ({
                        id: item.id,
                        subject_id: item.sub_id?.toString() || '',
                        teacher_id: item.teacher_id?.toString() || '',

                    }));


                    setAssignedSubjects(data);
                    setResponse2({ message: 'Assigned Subjects Fetched Successfully.', status: 'success' });
                } else {

                    setAssignedSubjects([])
                    setResponse2({ message: 'No Subjects Assigned for this Class & Section.', status: 'error' });
                }
            } else {
                setResponse2({ message: 'Something Went Wrong. Please try again.', status: 'error' });
            }
        } catch (error) {
            console.error('Fetch assigned subjects error:', error);
        } finally {
            setLoading(false);
            setTimeout(() => setResponse2({ message: '', status: '' }), 3000);
        }
    };


          const formatDate = (dateString) => {
        const date = new Date(dateString);

        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();

        return `${day}-${month}-${year} `;
    };



    return (
        <section className='py-4'>
            <div className='px-4'>
                <HeadingArea message1="Exam" message2="Exam Setup" />

                            {response2.message && <ResponseMsg2 message={response2.message} status={response2.status} />}
                <div className='row'>

                    <div className='col-xl-3 col-lg-4 col-md-5 col-12 my-2'>
                        <form>


                            <div className="profile-card">
                                <p className="profile-heading">Add Exam</p>

                                <div className="mb-4">
                                    {/* Exam Name */}

                                    < div className='mt-4'>


                                        <div className='profile-input-area mb-4'>
                                            <label className="profile-badge">Select AY*</label>
                                            <select
                                                className="profile-input"

                                                name='year'
                                                value={form.year}
                                                onChange={handleChange}
                                                required
                                            >
                                                <option value="">-- Select Academic Year --</option>
                                                {academicYears.map((ay) => (
                                                    <option key={ay.year} value={ay.year}>
                                                        {ay.year} --- {ay.title}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>


                                        <div className='profile-input-area mb-4'>
                                            <label className='profile-badge'>Exam Type*</label>
                                            <select
                                                className='profile-input'
                                                name='examType'
                                                value={form.examType}
                                                onChange={
                                                    handleChange}
                                                required
                                            >
                                                <option value=''>Select Type</option>
                                                {exam.map((type) => (
                                                    <option key={type.id} value={type.id}>
                                                        {type.exam_name}
                                                    </option>
                                                ))}
                                            </select>

                                        </div>




                                        <div className='profile-input-area mb-4'>
                                            <label className="profile-badge">Select Class*</label>
                                            <select
                                                className="profile-input"
                                                name='class_name'

                                                value={form.class_name?.classId || ''}
                                                onChange={(e) => {
                                                    handleChange(e);
                                                    const value = e.target.value;
                                                    setSelectedClassId(value);
                                                }}
                                                required
                                            >
                                                <option value="">-- Select Class --</option>
                                                {classes.map((cls) => (
                                                    <option key={cls.id} value={cls.id}>
                                                        {cls.class_name}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>

                                        <div className='profile-input-area mb-4'>
                                            <label className="profile-badge">Select Section*</label>


                                            <select
                                                className="profile-input"
                                                name='section'

                                                value={form.section}
                                                onChange={(e) => {
                                                    handleChange(e);
                                                    const value = e.target.value;
                                                    setSelectedSection(value);
                                                    fetchAssignSubject(selectedClassId, value);
                                                }}
                                                disabled={availableSections.length === 0}
                                                required
                                            >
                                                <option value="">-- Select Section --</option>
                                                {availableSections.map((section, idx) => (
                                                    <option key={idx} value={section}>
                                                        {section}
                                                    </option>
                                                ))}
                                            </select>

                                        </div>

                                        <div className='profile-input-area mb-4'>
                                            <label className='profile-badge'>Subject*</label>
                                            <select
                                                name='subject'
                                                value={form.subject}
                                                onChange={handleChange}
                                                className='profile-input'
                                                required
                                            >
                                                <option value=''>--- Select ---</option>
                                                {assignedSubjects.map((sub, index) => (
                                                    <option key={index} value={sub.sub_id}>
                                                        {sub.sub_name}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>


                                    </div>

                                    <div className='profile-input-area mb-4'>
    <label className='profile-badge'>Exam Date*</label>
    <input
        type='date'
        name='examDate'
        className='profile-input'
        value={form.examDate || ''}
        onChange={handleChange}
        required
    />
</div>


                                </div>

                            </div>


                            <div className='profile-card mt-2'>
                                {/* <div className="d-flex justify-content-between align-items-center">
                                    <p className='profile-heading my-0'>Add Mark Distributions</p>
                                    <button  className="border-0 bg-transparent cursor-pointer" type='button'

                                        onClick={handleAddRow}
                                    > <AiOutlinePlusCircle size={26} /> </button>
                                </div> */}

                                {/* <div className="table-responsive mt-3"> */}
                                    {/* <table className="table w-100">
                                        <thead className="account-thead rounded-top-4">
                                            <th>Exam Title</th>
                                            <th>Exam Mark</th>
                                            <th>Action</th>

                                        </thead>


                                        <tbody>
                                            {Array.isArray(rows) &&
                                                rows.map((row, index) => (
                                                    <tr key={index}>
                                                        <td>
                                                            <input
                                                                name='examTitle'
                                                                className='profile-input border border-primary rounded mt-1'
                                                                type='text'
                                                                value={row.examTitle}
                                                                onChange={(e) => handleChangeRow(index, 'examTitle', e.target.value)}
                                                            />
                                                        </td>
                                                        <td>
                                                            <input
                                                                name='examMark'
                                                                className='profile-input border border-primary rounded mt-1 mx-1'
                                                                type='number'
                                                                value={row.examMark}
                                                                onChange={(e) => handleChangeRow(index, 'examMark', e.target.value)}
                                                            />
                                                        </td>
                                                        <td className='align-content-center text-center'>
                                                                <AiOutlineMinusCircle size={26} className="text-danger cursor-pointer"
                                                                onClick={() => handleRemoveRow(index)}
 />
                                                        </td>
                                                    </tr>
                                                ))}
                                        </tbody>

                                    </table> */}

                                    {/* <div className='profile-input-area mt-4'>
                                        <label className='profile-badge'>Total Marks</label>
                                        <input
                                            name='total'
                                            className='profile-input'
                                            type='number'
                                            value={total}
                                            readOnly
                                        />
                                    </div> */}
    <div className='profile-input-area'>
        <label className='profile-badge'>Total Marks*</label>
        <input
            name='total'
            className='profile-input'
            type='number'
            value={form.total || ''}
            onChange={handleChange}
            required
        />
</div>

                                {/* </div> */}
                            </div>


                            <div className='profile-card mt-1'>
                                {/* Buttons */}
                                <div className="d-flex justify-content-center p-1">
                                    <button className="profile-btn" type="submit" onClick={handleSubmit}>
                                        <FaCheck /> Save
                                    </button>
                                </div>
                            </div>
                            {/* </div> */}
                        </form>
                    </div>



                    {/* Right side */}
                    <div className='col-xl-9 col-lg-8 col-md-7 col-12 my-2 h-100'>
                        <div className='profile-card'>
                            <div className='d-md-flex d-sm-flex justify-content-between mb-2'>
                                <span className="profile-heading align-content-center">Exam List</span>

                                <div className='profile-input-area ms-auto col-lg-3 border-0'>
                                    <input
                                        type='text'
                                        name='search'
                                        className='profile-input border-bottom rounded-0'
                                        placeholder='Search...'
                                        value={searchTerm}
                                        onChange={(e) => setSearchTerm(e.target.value)}
                                    />
                                </div>
                            </div>

                            <div className='table-responsive'>
                                <table className='w-100 text-center'>
                                    <thead className='account-thead'>
                                        <tr>
                                            <th className='rounded-start-4'>S No</th>
                                            <th>Exam Date</th>
                                            <th>Type</th>
                                            <th>Class</th>
                                            <th>Subject</th>
                                            <th >Total Mark</th>
                                            {/* <th>Distribution</th> */}
                                            <th className='rounded-end-4'>Action </th>
                                        </tr>
                                    </thead>


                                    <tbody>
                                        {filterExamSetup.map((item, index) => (
                                            <tr key={item.id || index} className="account-tr">
                                                <td>{index + 1}</td>
                                                <td>{formatDate(item.exam_date) || '—'}</td>
                                                <td>{item.exam_name || '—'}</td>
                                                <td>{item.class_name || '—'} ({item.section})</td>
                                                <td>{item.sub_name}</td>
                                                <td>{item.total_marks}</td>
{/* <td className='text-start'>
  {JSON.parse(item.exam_mark_distribution || '[]').map((e, i) => (
    <div key={i}>
      ● {e.examTitle}: {e.examMark}
    </div>
  ))}
</td> */}
                                                <td>
                                                    <FaCopy className='account-icon2 me-2' title='Copy' onClick={() => handleCopyStructure(item)} />
                                                    <RiDeleteBin6Line className='account-icon1' title='Remove' onClick={() => handleShowDelete(item)} />
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>

                                </table>
                            </div>

                        </div>
                    </div>
                    {showDelete && (
                        <>
                            <section className='ins-dialog'>
                                <div className='ins-dialog-inner col-lg-10 col-12 animate__animated animate__fadeInDown mx-auto' onClick={(e) => e.stopPropagation()}>

                                    <p className='ins-dialog-heading text-danger'>Remove This Exam!</p>

                                    <div className='table-responsive'>
                                        <table className='w-100'>

                                            <thead className='account-thead'>
                                            <th className='rounded-start-4'>Exam Date</th>
                                            <th>Type</th>
                                            <th>Class</th>
                                            <th>Subject</th>
                                            <th className='rounded-end-4'>Total Mark</th>
                                            {/* <th className='rounded-end-4'>Distribution</th> */}
                                            </thead>

                                            <tr className='account-tr'>
                                                <td>{formatDate(selectedExam.exam_date) || '—'}</td>
                                                <td>{selectedExam.exam_name || '—'}</td>
                                                <td>{selectedExam.class_name || '—'} ({selectedExam.section})</td>
                                                <td>{selectedExam.sub_name}</td>
                                                <td>{selectedExam.total_marks}</td>
{/* <td className='text-start'>
  {JSON.parse(selectedExam.exam_mark_distribution || '[]').map((e, i) => (
    <div key={i}>
      ● {e.examTitle}: {e.examMark}
    </div>
  ))}
</td> */}
                                            </tr>

                                        </table>
                                    </div>

                                    <p className='para-text mt-3'>Note: This action cannot be undone. Once deleted, the Exam Setup will be permanently removed.</p>

                                    <button className='profile-btn me-2' onClick={() => handleDelete(selectedExam.id)}>Remove</button>
                                    <button className='profile-btn2' onClick={() => setShowDelete(false)}>Go Back</button>


                                </div>
                            </section>
                        </>
                    )}
                </div>
            </div>
        </section>
    )
}

export default ExamSetup